// Constant Data for Seller::Inbound::InventoryBatch

export const PHOTO_STUDIO_LOCATION = {
  SMALL_STUDIO : 'small_studio',
  BIG_STUDIO   : 'big_studio'
}

export const PHOTO_STUDIO_STATUS = {
  PENDING  : 'pending',
  RECEIVED : 'received'
}

export const WAREHOUSE_STATUS = {
  PENDING  : 'pending',
  RECEIVED : 'received'
}

export const PHOTO_PROCESS_STATUS = {
  PENDING                : 'pending',
  PHOTOGRAPHY_COMPLETED  : 'photography_completed',
  PHOTO_EDIT_COMPLETED   : 'photo_edit_completed',
  PHOTO_UPLOAD_COMPLETED : 'photo_upload_completed'
}

export const PUT_AWAY_STATUS = {
  PENDING   : 'pending',
  PARTIAL   : 'partial',
  COMPLETED : 'completed'
}

/* constant for front-end only
 * used to MAP item-table-columns used in InventoryBatchTable
*/
export const PROCESS_STATUS = {
  PHOTO_STUDIO : 'photo_studio',
  PHOTO_EDITOR : 'photo_editor',
  WAREHOUSE    : 'warehouse'
}

export const HIDDEN_COLUMN = {
  PHOTO_STUDIO: [
    'warehouse_status',
    'warehouse_received_date',
    'put_away_status',
    'require_photography',
    'require_photo_edit'
  ],
  PHOTO_EDITOR: [
    'photo_studio_status',
    'require_photography',
    'photo_studio_received_date',
    'warehouse_status',
    'put_away_status',
    'require_photography',
    'require_photo_edit'
  ],
  WAREHOUSE: [
    'photo_studio_received_date',
    'photo_edited_completed_date',
    'require_photography',
    'photo_edited_date',
    'require_photography',
    'require_photo_edit'
  ]
}
